import {IdGenerator} from './type';

export default function createIdGenerator(): IdGenerator {
  let id = 0;

  return () => {
    id++;
    return id.toString();
  };
}